import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'

import { TableContainer, Table, Thead, Th, Tbody, Tr, Td } from 'components/v2/Table'
import { Dropdown } from 'components/v2/Dropdown'
import IconButton from 'components/v2/IconButton'
import { DotsIcon } from 'components/Icons'
import { StyledLink } from 'components/v2/Link'
import List from 'components/v2/List'
import { FEATURES } from 'features/Roles/components/Permissions/constants'
import { amenitiesMessages } from 'features/Lines/components/Amenities/messages'
import { LineClass } from 'features/Lines/components/Class'
import { safeFormatMessage } from 'utils/intl'
import { canWrite } from 'features/Users/utils'
import { useLogin } from 'features/Login/hooks'

const Logo = styled.img<TSFixMe>`
  width: auto;
  height: 30px;
`

export const LinesList = ({ lines = [] }): TSFixMe => {
  const intl = useIntl()

  const login = useLogin()

  return (
    <TableContainer overflow>
      <Table marginBottom>
        <Thead>
          <Tr>
            {canWrite(FEATURES.COMPANY_LINE, login.accessToken.policies) && <Th />}
            <Th>
              <FormattedMessage id="dictionary.logo" defaultMessage="Logo" />
            </Th>
            <Th>
              <FormattedMessage id="dictionary.name" defaultMessage="Name" />
            </Th>
            <Th>
              <FormattedMessage id="dictionary.class" defaultMessage="Class" />
            </Th>
            <Th>
              <FormattedMessage id="dictionary.amenities" defaultMessage="Amenities" />
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          {lines.map((line: TSFixMe): TSFixMe => {
            return (
              <Tr key={line.id}>
                {canWrite(FEATURES.COMPANY_LINE, login.accessToken.policies) && (
                  <Td>
                    <Dropdown
                      toggle={<IconButton icon={<DotsIcon />} noBorder smallPadding />}
                      noPadding
                      noIndicator
                      left
                    >
                      <List.Container>
                        <List.Item noPadding>
                          <List.Link to={`/lines/${line.id}`}>
                            <FormattedMessage id="lines.list.actions.edit" defaultMessage="Edit line" />
                          </List.Link>
                        </List.Item>
                      </List.Container>
                    </Dropdown>
                  </Td>
                )}
                <Td>
                  <Logo alt="Logo" src={line.logoPath} />
                </Td>
                <Td>{line.name}</Td>
                <Td>
                  <LineClass lineClass={line.class} />
                </Td>
                <Td>
                  {line.amenities.length > 0 ? (
                    <Dropdown toggle={<StyledLink>{line.amenities.length}</StyledLink>} noPadding>
                      <List.Container>
                        {line.amenities.map((amenity: TSFixMe): TSFixMe => {
                          return (
                            <List.Item key={amenity}>
                              {safeFormatMessage({ intl, messages: amenitiesMessages, key: amenity })}
                            </List.Item>
                          )
                        })}
                      </List.Container>
                    </Dropdown>
                  ) : (
                    0
                  )}
                </Td>
              </Tr>
            )
          })}
        </Tbody>
      </Table>
    </TableContainer>
  )
}
